'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _get = require('@babel/runtime-corejs3/helpers/get');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _Object$values = require('@babel/runtime-corejs3/core-js-stable/object/values');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _Number$isNaN = require('@babel/runtime-corejs3/core-js-stable/number/is-nan');
require('../data/index.js');
var expressionValidator = require('./expression-validator.js');
var operators_enum = require('./operators.enum.js');
var dataType_enum = require('../data/data-type.enum.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _Object$values__default = /*#__PURE__*/_interopDefaultLegacy(_Object$values);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _Number$isNaN__default = /*#__PURE__*/_interopDefaultLegacy(_Number$isNaN);

function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

/**
 * JSON format for expression.
 *
 * @export
 * @interface ExpressionJson
 */

/**
 * Parameter and return types of function.
 *
 * @export
 * @const FunctionMetaInfo
 */
var FunctionMetaInfo = new _Map__default["default"]([[operators_enum.FunctionType.ToFloat, {
  returnType: dataType_enum.DataType.Real,
  paramType: [dataType_enum.DataType.String]
}], [operators_enum.FunctionType.ToInt, {
  returnType: dataType_enum.DataType.Int,
  paramType: [dataType_enum.DataType.String]
}], [operators_enum.FunctionType.Concat, {
  returnType: dataType_enum.DataType.String,
  paramType: [dataType_enum.DataType.String, dataType_enum.DataType.String]
}], [operators_enum.FunctionType.TokenLen, {
  returnType: dataType_enum.DataType.Int,
  paramType: [dataType_enum.DataType.String]
}], [operators_enum.FunctionType.Sqrt, {
  returnType: dataType_enum.DataType.Real,
  paramType: [dataType_enum.DataType.Real]
}], [operators_enum.FunctionType.Sum, {
  returnType: dataType_enum.DataType.Real,
  paramType: [dataType_enum.DataType.Real]
}], [operators_enum.FunctionType.Min, {
  returnType: dataType_enum.DataType.Real,
  paramType: [dataType_enum.DataType.Real]
}], [operators_enum.FunctionType.Max, {
  returnType: dataType_enum.DataType.Real,
  paramType: [dataType_enum.DataType.Real]
}], [operators_enum.FunctionType.Avg, {
  returnType: dataType_enum.DataType.Real,
  paramType: [dataType_enum.DataType.Real]
}], [operators_enum.FunctionType.Count, {
  returnType: dataType_enum.DataType.Int,
  paramType: []
}], [operators_enum.FunctionType.DistinctCount, {
  returnType: dataType_enum.DataType.Int,
  paramType: [dataType_enum.DataType.Unknown]
}], [operators_enum.FunctionType.Collect, {
  returnType: dataType_enum.DataType.Collection,
  paramType: [dataType_enum.DataType.Unknown]
}], [operators_enum.FunctionType.DistinctCollect, {
  returnType: dataType_enum.DataType.Collection,
  paramType: [dataType_enum.DataType.Unknown]
}]]);

/**
 * Base class for expression.
 *
 * @export
 * @abstract
 * @class BaseExpression
 */
var BaseExpression = /*#__PURE__*/function () {
  function BaseExpression(operands, operator) {
    _classCallCheck__default["default"](this, BaseExpression);
    this.operands = operands;
    this.operator = operator;
  }
  return _createClass__default["default"](BaseExpression, [{
    key: "getReferredVertexOrEdgeTypes",
    value: function getReferredVertexOrEdgeTypes() {
      var types = [];
      if (this.operands) {
        var _context;
        _forEachInstanceProperty__default["default"](_context = this.operands).call(_context, function (operand) {
          return types.push.apply(types, _toConsumableArray__default["default"](operand.getReferredVertexOrEdgeTypes()));
        });
      }
      return types;
    }
  }, {
    key: "evaluate",
    value: function evaluate() {
      return {
        applicable: false
      };
    }
  }]);
}();

/**
 * Class for handling undefined expression.
 *
 * @export
 * @class NullExpression
 * @extends {BaseExpression}
 */
var NullExpression = /*#__PURE__*/function (_BaseExpression) {
  function NullExpression() {
    _classCallCheck__default["default"](this, NullExpression);
    return _callSuper(this, NullExpression, [undefined, undefined]);
  }
  _inherits__default["default"](NullExpression, _BaseExpression);
  return _createClass__default["default"](NullExpression, [{
    key: "getType",
    value: function getType() {
      return dataType_enum.DataType.Unknown;
    }
  }, {
    key: "toString",
    value: function toString() {
      return '';
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'NullExpression',
        operands: []
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      return {
        success: false,
        errors: ['Please choose expression type.']
      };
    }
  }]);
}(BaseExpression);

/**
 * Class for function expression.
 *
 * @export
 * @class FuncExpression
 * @extends {BaseExpression}
 */
var FunctionExpression = /*#__PURE__*/function (_BaseExpression2) {
  function FunctionExpression(operands, operator) {
    var _this;
    _classCallCheck__default["default"](this, FunctionExpression);
    _this = _callSuper(this, FunctionExpression, [operands, operator]);
    _defineProperty__default["default"](_this, "operandsTypes", [['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', 'BoolConstant', 'IntParam', 'RealParam', 'BoolParam', 'StringParam', 'IntAccum', 'RealAccum', 'StringAccum', 'BoolAccum', 'LoadingVariable', 'AttrVariable', 'AttrVariableWithAlias', 'AliasReference', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power]]);
    return _this;
  }
  _inherits__default["default"](FunctionExpression, _BaseExpression2);
  return _createClass__default["default"](FunctionExpression, [{
    key: "getType",
    value: function getType() {
      return FunctionMetaInfo.get(this.operator).returnType;
    }
  }, {
    key: "toString",
    value: function toString() {
      var _context4;
      // For COUNT(*), directly return it as the expression.
      if (this.operator === operators_enum.FunctionType.Count) {
        return this.operator;
      } else if (this.operator === operators_enum.FunctionType.DistinctCount) {
        var _context2;
        return "COUNT(DISTINCT ".concat(_mapInstanceProperty__default["default"](_context2 = this.operands).call(_context2, function (operand) {
          return operand.toString();
        }).join(','), ")");
      } else if (this.operator === operators_enum.FunctionType.DistinctCollect) {
        var _context3;
        return "COLLECT(DISTINCT ".concat(_mapInstanceProperty__default["default"](_context3 = this.operands).call(_context3, function (operand) {
          return operand.toString();
        }).join(','), ")");
      }
      return "".concat(this.operator) + "(".concat(_mapInstanceProperty__default["default"](_context4 = this.operands).call(_context4, function (operand) {
        return operand.toString();
      }).join(','), ")");
    }
  }, {
    key: "toJson",
    value: function toJson() {
      var _context5;
      return {
        type: 'FunctionExpression',
        operator: this.operator,
        operands: _mapInstanceProperty__default["default"](_context5 = this.operands).call(_context5, function (operand) {
          return operand.toJson();
        })
      };
    }

    // Here we assume that operands are not undefined.
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var _context6, _context7;
      if (!_includesInstanceProperty__default["default"](_context6 = _Object$values__default["default"](operators_enum.FunctionType)).call(_context6, this.operator)) {
        return {
          success: false,
          errors: ['This expression contains an unsupported function type. ' + 'Did you import a solution from a higher version of GraphStudio?']
        };
      }
      for (var i = 0; i < this.operands.length; i++) {
        if (!this.operands[i].semanticCheck().success) {
          return {
            success: false,
            errors: []
          };
        }
      }
      var passSemanticCheck = true;
      var semanticErrors = [];
      var operandsArray = this.operands;
      var functionReturnObject = FunctionMetaInfo.get(this.operator);
      var lengthOfParamType = functionReturnObject.paramType.length;
      if (operandsArray.length !== lengthOfParamType) {
        // if number of operands doesn't fit the number of expected parameters
        return {
          success: false,
          errors: ["Expect ".concat(lengthOfParamType) + ' argument(s), but get ' + "".concat(this.operands.length, ".")]
        };
      }
      _forEachInstanceProperty__default["default"](_context7 = functionReturnObject.paramType).call(_context7, function (type, index) {
        // Check type compatible one by one in range of meta specified param number.
        var operandType = operandsArray[index].getType();
        if (type !== dataType_enum.DataType.Unknown && operandType !== type && !(expressionValidator.ExpressionValidator.isReal(type) && expressionValidator.ExpressionValidator.isInt(operandType))) {
          var _context8;
          // Integer type can be treated as real type even the type name are different.
          passSemanticCheck = false;
          semanticErrors.push(_concatInstanceProperty__default["default"](_context8 = "Expression".concat(index + 1, " should be ")).call(_context8, type, ", ") + "not ".concat(operandsArray[index].getType(), "."));
        }
      });
      return {
        success: passSemanticCheck,
        errors: semanticErrors
      };
    }
  }]);
}(BaseExpression);

/**
 * Class for arithmetic expression.
 *
 * @export
 * @class ArithExpression
 * @extends {BaseExpression}
 */
var ArithmeticExpression = /*#__PURE__*/function (_BaseExpression3) {
  function ArithmeticExpression(operands, operator) {
    var _this2;
    _classCallCheck__default["default"](this, ArithmeticExpression);
    _this2 = _callSuper(this, ArithmeticExpression, [operands, operator]);
    _defineProperty__default["default"](_this2, "operandsTypes", [['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', 'BoolConstant', 'IntParam', 'RealParam', 'BoolParam', 'StringParam', 'IntAccum', 'RealAccum', 'StringAccum', 'BoolAccum', 'LoadingVariable', 'AttrVariable', 'AttrVariableWithAlias', 'Function', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power], ['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', 'BoolConstant', 'IntParam', 'RealParam', 'BoolParam', 'StringParam', 'IntAccum', 'RealAccum', 'StringAccum', 'BoolAccum', 'LoadingVariable', 'AttrVariable', 'AttrVariableWithAlias', 'Function', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power]]);
    return _this2;
  }
  _inherits__default["default"](ArithmeticExpression, _BaseExpression3);
  return _createClass__default["default"](ArithmeticExpression, [{
    key: "getType",
    value: function getType() {
      if (this.operands[0].getType() === this.operands[1].getType()) {
        return this.operands[0].getType();
      } else {
        return dataType_enum.DataType.Real;
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      var _context9, _context10;
      return _concatInstanceProperty__default["default"](_context9 = _concatInstanceProperty__default["default"](_context10 = "(".concat(this.operands[0], " ")).call(_context10, this.operator, " ")).call(_context9, this.operands[1], ")");
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'ArithmeticExpression',
        operator: this.operator,
        operands: [this.operands[0].toJson(), this.operands[1].toJson()]
      };
    }

    // Here we assume that operands are not undefined.
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var _context11, _context12;
      if (!_includesInstanceProperty__default["default"](_context11 = _Object$values__default["default"](operators_enum.ArithmeticOperator)).call(_context11, this.operator)) {
        return {
          success: false,
          errors: ['This expression contains an unsupported arithmetic expression type. ' + 'Did you import a solution from a higher version of GraphStudio?']
        };
      }
      if (!this.operands[0].semanticCheck().success || !this.operands[1].semanticCheck().success) {
        return {
          success: false,
          errors: []
        };
      }
      var leftOperandType = this.operands[0].getType();
      var rightOperandType = this.operands[1].getType();
      if ((!expressionValidator.ExpressionValidator.isInt(leftOperandType) || !expressionValidator.ExpressionValidator.isInt(rightOperandType)) && this.operator === operators_enum.ArithmeticOperator.Mod) {
        return {
          success: false,
          errors: ["Both operands must be integers for operator \"".concat(this.operator.toString(), "\".")]
        };
      }
      if (expressionValidator.ExpressionValidator.isNumeric(leftOperandType) && expressionValidator.ExpressionValidator.isNumeric(rightOperandType)) {
        return {
          success: true,
          errors: []
        };
      }
      if (expressionValidator.ExpressionValidator.isString(leftOperandType) && expressionValidator.ExpressionValidator.isString(rightOperandType) && this.operator === operators_enum.ArithmeticOperator.Plus
      // + operator can be used with two string, performs as concat.
      ) {
        return {
          success: true,
          errors: []
        };
      }
      return {
        success: false,
        errors: [_concatInstanceProperty__default["default"](_context12 = "".concat(leftOperandType, " and ")).call(_context12, rightOperandType, " are incompatible ") + "for operator \"".concat(this.operator.toString(), "\".")]
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var leftOperandEvalResult = this.operands[0].evaluate(nodeOrLink);
      var rightOperandEvalResult = this.operands[1].evaluate(nodeOrLink);
      var falseResult = {
        applicable: false
      };
      if (!leftOperandEvalResult.applicable || !rightOperandEvalResult.applicable) {
        return falseResult;
      }
      var evalResult;
      switch (this.operator.toString()) {
        case '+':
          {
            evalResult = typeof leftOperandEvalResult.value === 'number' ? leftOperandEvalResult.value + rightOperandEvalResult.value : leftOperandEvalResult.value + rightOperandEvalResult.value;
            break;
          }
        case '-':
          {
            evalResult = leftOperandEvalResult.value - rightOperandEvalResult.value;
            break;
          }
        case '*':
          {
            evalResult = leftOperandEvalResult.value * rightOperandEvalResult.value;
            break;
          }
        case '/':
          {
            evalResult = leftOperandEvalResult.value / rightOperandEvalResult.value;
            break;
          }
        case '%':
          {
            evalResult = leftOperandEvalResult.value % rightOperandEvalResult.value;
            break;
          }
        case '^':
          {
            evalResult = Math.pow(leftOperandEvalResult.value, rightOperandEvalResult.value);
            break;
          }
      }
      if (_Number$isNaN__default["default"](evalResult) || evalResult === Infinity) {
        return falseResult;
      } else {
        return {
          applicable: true,
          value: evalResult
        };
      }
    }
  }]);
}(BaseExpression);

/**
 * Class for arithmetic expression in WHERE clause.
 * Since '+' can not be used with 2 strings in WHERE clause of a loading job,
 * we need to check more for WHERE clause.
 *
 * @export
 * @class ArithmeticExpressionInWhereClause
 * @extends {ArithmeticExpression}
 */
var ArithmeticExpressionInWhereClause = /*#__PURE__*/function (_ArithmeticExpression2) {
  function ArithmeticExpressionInWhereClause() {
    _classCallCheck__default["default"](this, ArithmeticExpressionInWhereClause);
    return _callSuper(this, ArithmeticExpressionInWhereClause, arguments);
  }
  _inherits__default["default"](ArithmeticExpressionInWhereClause, _ArithmeticExpression2);
  return _createClass__default["default"](ArithmeticExpressionInWhereClause, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'ArithmeticExpressionInWhereClause',
        operator: this.operator,
        operands: [this.operands[0].toJson(), this.operands[1].toJson()]
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var passSemanticCheck = _get__default["default"](_getPrototypeOf__default["default"](ArithmeticExpressionInWhereClause.prototype), "semanticCheck", this).call(this);
      if (!passSemanticCheck.success) {
        return passSemanticCheck;
      }
      if (this.operator === operators_enum.ArithmeticOperator.Plus) {
        passSemanticCheck.success = expressionValidator.ExpressionValidator.isNumeric(this.operands[0].getType()) && expressionValidator.ExpressionValidator.isNumeric(this.operands[1].getType());
        if (!passSemanticCheck.success) {
          passSemanticCheck.errors.push('Only numeric type operands can be used ' + 'with + operator in WHERE clause.');
        }
      }
      return passSemanticCheck;
    }
  }]);
}(ArithmeticExpression);

/**
 * Class for arithmetic expression in an aggregation function.
 * The arithmetic expression in the aggregation function
 * shall not include Function as an option.
 * @export
 * @class ArithmeticExpressionInAggregationFunction
 * @extends {ArithmeticExpression}
 */
var ArithmeticExpressionInAggregationFunction = /*#__PURE__*/function (_ArithmeticExpression3) {
  function ArithmeticExpressionInAggregationFunction() {
    var _context13;
    var _this3;
    _classCallCheck__default["default"](this, ArithmeticExpressionInAggregationFunction);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this3 = _callSuper(this, ArithmeticExpressionInAggregationFunction, _concatInstanceProperty__default["default"](_context13 = []).call(_context13, args));
    _defineProperty__default["default"](_this3, "operandsTypes", [['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', 'BoolConstant', 'IntParam', 'RealParam', 'BoolParam', 'StringParam', 'IntAccum', 'RealAccum', 'StringAccum', 'BoolAccum', 'LoadingVariable', 'AttrVariable', 'AttrVariableWithAlias', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power], ['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', 'BoolConstant', 'IntParam', 'RealParam', 'BoolParam', 'StringParam', 'IntAccum', 'RealAccum', 'StringAccum', 'BoolAccum', 'LoadingVariable', 'AttrVariable', 'AttrVariableWithAlias', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power]]);
    return _this3;
  }
  _inherits__default["default"](ArithmeticExpressionInAggregationFunction, _ArithmeticExpression3);
  return _createClass__default["default"](ArithmeticExpressionInAggregationFunction, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'ArithmeticExpressionInAggregationFunction',
        operator: this.operator,
        operands: [this.operands[0].toJson(), this.operands[1].toJson()]
      };
    }
  }]);
}(ArithmeticExpression);

exports.ArithmeticExpression = ArithmeticExpression;
exports.ArithmeticExpressionInAggregationFunction = ArithmeticExpressionInAggregationFunction;
exports.ArithmeticExpressionInWhereClause = ArithmeticExpressionInWhereClause;
exports.BaseExpression = BaseExpression;
exports.FunctionExpression = FunctionExpression;
exports.FunctionMetaInfo = FunctionMetaInfo;
exports.NullExpression = NullExpression;
